/**
 * Membership tier → presentation.
 *
 * Shared so the header avatar ring and the wallet pill can never disagree about
 * which colour a plan is; the tier test used to live inline in
 * `wallet-balance.tsx` only.
 */

export type PlanTier = "free" | "premium" | "paid"

export function getPlanTier(activePlan?: string | null): PlanTier {
    const plan = activePlan?.trim()
    if (!plan || plan === "Free") return "free"
    return plan.toLowerCase().includes("premium") ? "premium" : "paid"
}

export function getPlanLabel(activePlan?: string | null): string {
    return activePlan?.trim() || "Free"
}

/**
 * Ring worn by the header avatar. On mobile there is no room for the plan pill,
 * so the ring stands in for it — the plan name still reaches screen readers
 * through the avatar button's accessible name, so the colour is never the only
 * carrier of the information.
 */
export const PLAN_RING_CLASS: Record<PlanTier, string> = {
    free: "ring-indigo-500 dark:ring-indigo-400",
    premium: "ring-purple-500 dark:ring-purple-400",
    // Deeper amber on light themes: amber-500 measures only 1.99–2.15:1 against
    // the four light backgrounds, so the ring all but disappeared. amber-700
    // clears the 3:1 non-text minimum everywhere (4.64 worst case, in `ielts`),
    // and amber-400 does the same on the dark ones (11.65).
    paid: "ring-amber-700 dark:ring-amber-400",
}
